function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M384 702 c-6 -4 -82 -130 -169 -281 -122 -212 -155 -278 -148 -290 9 -14 50 -16 333 -16 283 0 324 2 333 16 7 12 -26 78 -148 290 -144 249 -170 289 -185 289 -3 0 -10 -4 -16 -8z m173 -274 c84 -145 155 -271 158 -281 7 -16 -12 -17 -315 -17 -303 0 -322 1 -315 18 11 30 309 542 315 542 3 0 74 -118 157 -262z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M360 502 c0 -16 3 -63 6 -105 7 -75 8 -77 34 -77 26 0 27 2 34 77 11 136 12 133 -34 133 -37 0 -40 -2 -40 -28z m55 -74 c-11 -123 -20 -123 -30 0 -7 80 -7 82 15 82 22 0 22 -2 15 -82z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M370 275 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z m46 -16 c10 -17 -13 -36 -27 -22 -12 12 -4 33 11 33 5 0 12 -5 16 -11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M370 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M410 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M490 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M570 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M610 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M650 170 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
}));

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80.000000pt",
    height: "80.000000pt",
    viewBox: "0 0 80.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.4f4924c2.svg";
export { ForwardRef as ReactComponent };